import apiClient from './client';

export const WORKSPACE_SCHEMA_VERSION = 1 as const;

export interface WorkspaceCardLayoutItem {
  i: string;
  x: number;
  y: number;
  w: number;
  h: number;
}

export interface WorkspaceCardLayouts {
  lg: WorkspaceCardLayoutItem[];
  md: WorkspaceCardLayoutItem[];
  sm: WorkspaceCardLayoutItem[];
}

export interface WorkspaceLayoutPreference {
  schemaVersion: typeof WORKSPACE_SCHEMA_VERSION;
  orderedCardIds: string[];
  pinnedCardIds: string[];
  cardLayouts?: WorkspaceCardLayouts;
  updatedAt: string;
}

export interface WorkspaceLayoutInput {
  schemaVersion: typeof WORKSPACE_SCHEMA_VERSION;
  orderedCardIds: string[];
  pinnedCardIds: string[];
  cardLayouts: WorkspaceCardLayouts;
}

interface ApiEnvelope<T> {
  success: boolean;
  data: T;
}

export async function getWorkspacePreferences(): Promise<WorkspaceLayoutPreference | null> {
  const response = await apiClient.get<ApiEnvelope<{ layout: WorkspaceLayoutPreference | null }>>(
    '/api/workspace/preferences'
  );
  return response.data.data.layout;
}

export async function putWorkspacePreferences(
  layout: WorkspaceLayoutInput
): Promise<WorkspaceLayoutPreference> {
  const response = await apiClient.put<ApiEnvelope<{ layout: WorkspaceLayoutPreference }>>(
    '/api/workspace/preferences',
    { layout }
  );
  return response.data.data.layout;
}
